import { INtrReq, NutrientType } from "../../../types"
import { NutrientDef } from "../nutrient-def"

/// <reference path="../nutrient-def.ts" />

export class NutrientViewModel {

    public key: string
    public htmlText: string
    public selected: boolean

    value: number;
    private _initValue: number;

    constructor(private def: NutrientDef, req: INtrReq) {

        let key = def.key;

        this.key = def.key;
        this.htmlText = def.htmlText;

        this._initValue = this.value = req["Required" + key];

    }

    get nutrientType(): NutrientType {
        return this.def.nutrientType;
    }

    get nutrientMask(): number {
        return Math.pow(2, this.def.nutrientType - 1);
    }

    public hasChanged(): boolean {
        return this.value != this._initValue;
    }

    get tonnesPerHa(): boolean {
        return this.def.tonnesPerHa;
    }

}

